exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1JOYI-RWZyYRxy ._1otVmD9AG4HjJM{color:#172b4d;font-size:16px;font-weight:600;letter-spacing:-.006em;line-height:20px;margin-top:24px;margin-top:0;text-align:center}._1JOYI-RWZyYRxy ._3tPk2hLgTnprFB{height:40px;line-height:20px;color:#5e6c84;text-align:center}._1JOYI-RWZyYRxy ._1wsqHzW7HmECRq{color:#5e6c84;margin-top:26px;text-align:center}._2dBsWKlnfAauND{display:flex;flex-direction:row;height:36px;border-radius:3px;background-color:#f4f5f7;margin-bottom:4px}._2dBsWKlnfAauND p{margin-top:auto;font-size:14px;max-width:200px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}._1y7ziODLsywoHT{margin-right:8px;margin-left:0;min-width:36px}._1y7ziODLsywoHT,._1y7ziODLsywoHT img{border-radius:3px 0 0 3px;width:36px;height:36px}._1y7ziODLsywoHT img{object-fit:fill}._1delCD1b6cKWB5{margin-left:auto;margin-top:-1px}._3AFsAkTFRTM0-O{margin-bottom:0}", ""]);

// exports
exports.locals = {
	"addBoards": "_1JOYI-RWZyYRxy",
	"promptTitle": "_1otVmD9AG4HjJM",
	"promptDesc": "_3tPk2hLgTnprFB",
	"promptFooter": "_1wsqHzW7HmECRq",
	"boardListEntry": "_2dBsWKlnfAauND",
	"backgroundTile": "_1y7ziODLsywoHT",
	"checkbox": "_1delCD1b6cKWB5",
	"addBoardsButton": "_3AFsAkTFRTM0-O"
};